import { render } from "./BitacoraApp.vue?vue&type=template&id=8af483f6&scoped=true"
import script from "./BitacoraApp.vue?vue&type=script&lang=js"
export * from "./BitacoraApp.vue?vue&type=script&lang=js"

import "./BitacoraApp.vue?vue&type=style&index=0&id=8af483f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af483f6"]])

export default __exports__